import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors,
} from "chart.js";
import { computed, ref } from "vue";

import { withDefaults } from "vue";

type Data = number[] | Array<{ data: number[]; label: string[] }>;

export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    data: null,
    label: null,
    horizontal: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, data: Data, label: string[], horizontal: boolean }

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors
);



const options = computed(() => ({
  indexAxis: props.horizontal ? "y" : "x",
  plugins: {
    title: {
      display: true,
      text: props.title,
    },
    legend: {
      display: typeof props.data?.[0] !== "number",
      position: "bottom",
    },
    datalabels: {
      display: false,
    },
  },
}));

const chartData = computed(() => {
  if (typeof props.data?.[0] === "number") {
    return {
      labels: props.label,
      datasets: [{ data: props.data }],
    };
  }

  return {
    labels: props.label,
    datasets: props.data,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Bar), {
      data: _unref(chartData),
      options: _unref(options)
    }, null, 8, ["data", "options"])
  ]))
}
}

})